import { isAllowedCreative } from '@web-platform/shared-universal-utils-frontend/src/helpers/adverts';
import { extractCreativesPlugin } from '@web-platform/shared-universal-utils-frontend/src/helpers/extractCreativesPlugin';
import {
  isFlightsResponseSuccessAndValid,
  isRadarResponse,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/flightsResponse';
import { isResponseContainFlightsBody } from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';

import { transformCreativeToAdvert } from '../../../shared/adverts/flightsDayView/transformConductorCreativeToAdvert';
import transformStrevdaSlotToAdvert from '../../../shared/adverts/flightsDayView/transformStrevdaSlotToAdvert';

import type { AdvertTrackingInfo } from '@skyscanner/strevda-tracking';
import type { ConductorPayloadResponseSuccess } from '@web-platform/shared-universal-types/src/network/acorn/endpoints';
import type { RadarResponsePayloadSuccess } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarResponsePayloadTypes';
import type { StrevdaSlotsPayloadResponseSuccess } from '@web-platform/shared-universal-types/src/network/types';
import type { Advert } from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';
import type {
  MutationResponseAction,
  QueryResponseAction,
  SponsoredContentLoadedAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const mapStrevdaSlotsToAdvertState = (
  response: StrevdaSlotsPayloadResponseSuccess,
): Advert[] => {
  const { body: slots } = response;
  return slots.map(transformStrevdaSlotToAdvert);
};
export const mapConductorCreativesToAdvertState = (
  response: ConductorPayloadResponseSuccess,
): Advert[] => {
  const { plugins } = response.body;
  const creativesPlugin = extractCreativesPlugin(plugins);
  return creativesPlugin && creativesPlugin.creatives
    ? creativesPlugin.creatives
        .filter((creative) => isAllowedCreative(creative))
        .map((creative) => transformCreativeToAdvert(creative, false))
    : [];
};
export const mapRadarCreativesToAdvertState = (response: RadarResponsePayloadSuccess): Advert[] => {
  if (!isResponseContainFlightsBody(response)) {
    return [];
  }
  const { creatives } = response.body.itineraries;
  return creatives
    ? creatives
        .filter((creative) => isAllowedCreative(creative))
        .map((creative) => transformCreativeToAdvert(creative, true))
    : [];
};
export const getAdvertsFromRadarResponse = (
  action: MutationResponseAction | QueryResponseAction,
): Advert[] | null => {
  const { response, type } = action.payload;
  if (!isFlightsResponseSuccessAndValid(type, response)) {
    return null;
  }
  return isRadarResponse(type, response)
    ? mapRadarCreativesToAdvertState(response)
    : mapConductorCreativesToAdvertState(response);
};

export const getAdvertFromSponsoredContentResponse = (
  action: SponsoredContentLoadedAction,
): AdvertTrackingInfo => {
  const { trackingData } = action.payload.sponsoredContent.payload;
  return trackingData;
};
